import { Provider } from '@angular/core';

import { UserApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const SubstanceUserGrpcContractProvider: Provider = {
  provide: UserApi.SubstanceUserWebGrpcContractClient,
  useFactory: CommonGrpcContractFactory(UserApi.SubstanceUserWebGrpcContractClient, 'userApi'),
};
